module.exports = __webpack_public_path__ + "img/clock-icon.826d0ca5.svg";